import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import React, { useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import dlsCard from '../../styles/dlsCard.js';
import dlsCardTilt from '../../styles/dlsCardTilt.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var cardSizes = {
  xs: 'dlsCardXs',
  sm: 'dlsCardSm',
  md: 'dlsCardMd',
  lg: 'dlsCardLg',
  xl: 'dlsCardXl'
};
var dlsCardTilt__dlsCardTiltLeft = dlsCardTilt.dlsCardTilt__dlsCardTiltLeft,
    dlsCardTilt__dlsCardTiltRight = dlsCardTilt.dlsCardTilt__dlsCardTiltRight,
    dlsCardTilt__dlsCardTiltContainer = dlsCardTilt.dlsCardTilt__dlsCardTiltContainer;

var leftStyle = _objectSpread(_objectSpread({}, dlsCardTilt__dlsCardTiltLeft), {}, {
  '&:hover + div:nth-of-type(2) + div:last-of-type': dlsCardTilt__dlsCardTiltLeft['&:hover + .dlsCardTiltRight + .dlsCardTiltContainer'],
  '&:hover + div + div:last-of-type::before': dlsCardTilt__dlsCardTiltLeft['&:hover + .dlsCardTiltRight + .dlsCardTiltContainer::before']
});

var rightStyle = _objectSpread(_objectSpread({}, dlsCardTilt__dlsCardTiltRight), {}, {
  '&:hover + div:last-of-type': dlsCardTilt__dlsCardTiltRight['&:hover + .dlsCardTiltContainer'],
  '&:hover + div:last-of-type::before': dlsCardTilt__dlsCardTiltRight['&:hover + .dlsCardTiltContainer::before']
});

function CardArt(_ref) {
  var size = _ref.size,
      theme = _ref.theme,
      tilt = _ref.tilt,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["size", "theme", "tilt", "children"]);

  var cardArtStyle = useMemo(function () {
    var styles = _objectSpread(_objectSpread({}, dlsCard[cardSizes[size]]), theme);

    if (tilt) {
      styles = _objectSpread(_objectSpread({}, styles), dlsCardTilt.dlsCardTilt);
    }

    return styles;
  }, [theme, size, tilt]);
  return jsx("div", _extends({
    css: cardArtStyle
  }, otherProps), tilt ? jsx(React.Fragment, null, jsx("div", {
    css: leftStyle
  }), jsx("div", {
    css: rightStyle
  }), jsx("div", {
    css: dlsCardTilt__dlsCardTiltContainer
  }, children)) : children);
}

CardArt.defaultProps = {
  size: undefined,
  tilt: false,
  theme: undefined,
  children: null
};

export default CardArt;
